<template>
    <div class="modal fade" id="contractTerminateModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="mdi mdi-close"></i></span></button>
                    <h4 class="modal-title">{{ lang.get('users.contracts.title.terminate_contract') }}</h4>
                </div>
                <div class="modal-body">
                    <div class="form-horizontal">
                        <div class="form-group">
                            <label class="control-label col-sm-2">{{ lang.get('users.contracts.label.enddate') }}:</label>
                            <div class="col-sm-4">
                                <date-picker v-model="form.endDate" format="DD-MM-YYYY" type="date" lang="en"></date-picker>
                            </div>
                        </div>
                    </div>
                    <p><em>{{ lang.get('users.contracts.msg.info.deactivation_on_end_date') }}</em></p>
                </div>
                <div class="modal-footer">
                    <div class="row">
                        <div class="col-sm-6 text-left">
                            <button @click="close()" class="btn btn-sm btn-default">{{ lang.get("global.no") }}</button>
                        </div>
                        <div class="col-sm-6">
                            <button @click="fire()" class="btn btn-sm btn-primary">{{ lang.get("global.yes") }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import moment from 'moment';
    import Hub from '../../../../Hub';
    import Lang from '../../../../Lang';
    import DatePicker from "vue2-datepicker";

    export default {
        components: {
            DatePicker,
        },

        data() {
            return {
                contract: {
                    contractnumber: null,
                },
                form: {
                    endDate: null,
                },
                lang: Lang,
            }
        },

        destroyed() {
            Hub.$off('show-terminate-modal', this.set);
        },

        methods: {
            close() {
                $('#contractTerminateModal').modal('hide');
            },

            open() {
                $('#contractTerminateModal').modal('show');
            },

            set(contract) {
                this.contract = contract;
                this.form.endDate = (contract.end ? moment(contract.end, 'DD-MM-YYYY') : moment()).toDate();
                this.open();
            },

            fire() {
                Hub.$emit('perform-terminate-action', this.contract, this.form.endDate);
                this.close();
            }
        },

        mounted() {
            this.$nextTick(function () {
                Hub.$on('show-terminate-modal', this.set);
            }.bind(this));
        },
    }
</script>
